<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Book_Claim_Num">Claim #</label>
              <input
                myFocus
                type="text"
                name="Book_Claim_Num"
                [(ngModel)]="dsCollection.criteria.Book_Claim_Num"
                ngControl="Contract_Num"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="button"
              (click)="dsCollection.criteria.Book_Claim_Num = ''; model.dirty = true"
              classes="secondary"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #claimFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th>Claim Num</th>
              <th>Contract Num</th>
              <th>LOB</th>
              <th>Consumer</th>
              <th>Claimant</th>
            </tr>
            <tr
              *ngFor="
                let claim of dsCollection.objectNodes | epFilter : claimFilter.filter : claimFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(claim)"
            >
              <td>
                {{ claim.Book_Claim_Num }}
              </td>
              <td>
                {{ claim.Contract.Contract_Num }}
              </td>
              <td>
                {{ claim.Line_Code_Desc }}
              </td>
              <td>
                {{ claim.Consumer.Entity_Name }}
              </td>
              <td>
                {{ claim.Claimant.Entity_Name }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Policies</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
